import { CompanyInfosFragment, SearchCompanyInfosFragment } from '@blockpulse3/graphql/hooks';
import { formatCountry } from '@blockpulse3/helpers';

import { OwnerForm } from './types';

export function getCompanyOwners(data: CompanyInfosFragment | undefined): OwnerForm[] {
  if (!data || !data?.ubos) {
    return [];
  }

  return data.ubos?.map((ubo) => ({
    id: ubo.id,
    individualIdentityId: ubo.individualIdentityId,
    firstName: ubo.firstName,
    lastName: ubo.lastName,
    birthCityPostalCode: ubo.birthCityPostalCode,
    birthCountry: {
      label: formatCountry(ubo.birthCountry || 'FRA'),
      value: ubo.birthCountry || 'FRA',
    },
    birthdate: ubo.birthdate,
    birthplace: ubo.birthplace,
    address: {
      line: ubo.address?.line || '',
      city: ubo.address?.city || '',
      postalCode: ubo.address?.postalCode || '',
      country: {
        label: formatCountry(ubo.address?.country || 'FRA'),
        value: ubo.address?.country || 'FRA',
      },
    },
    isDirect: ubo.isDirect,
    role: ubo.role,
    sharePercentage: ubo.sharePercentage,
  }));
}

export function getPappersOwners(data: SearchCompanyInfosFragment | undefined | null): OwnerForm[] {
  if (!data || !data?.ubos) {
    return [];
  }

  return data.ubos.map((ubo) => ({
    id: ubo.id,
    individualIdentityId: ubo.individualIdentityId,
    firstName: ubo.firstName,
    lastName: ubo.lastName,
    birthCityPostalCode: ubo.birthCityPostalCode,
    birthCountry: {
      label: formatCountry(ubo.birthCountry || 'FRA'),
      value: ubo.birthCountry || 'FRA',
    },
    birthdate: ubo.birthdate,
    birthplace: ubo.birthplace,
    address: {
      line: ubo.address?.line || '',
      city: ubo.address?.city || '',
      postalCode: ubo.address?.postalCode || '',
      country: {
        label: formatCountry(ubo.address?.country || 'FRA'),
        value: ubo.address?.country || 'FRA',
      },
    },
    isDirect: ubo.isDirect,
    role: ubo.role,
    sharePercentage: ubo.sharePercentage,
  }));
}
